<template>
  <v-dialog v-model="visible" width="75rem" persistent scrollable>
    <v-card v-if="is_loading">
      <v-skeleton-loader type="card, list-item@8" />
    </v-card>
    <template v-else>
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <sabira_icon icon="ko" class="mr-3" :strokewidth="3" fill="white" />
          <v-toolbar-title class="ml-1" v-if="ko.id > 0">
            {{ ko.ko_number }}
          </v-toolbar-title>
          <v-toolbar-title class="ml-1" v-else>
            {{ title2 }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="text-h5 mr-4">
            {{ $n(parseFloat(grand_total).toFixed(2)) }} KM
          </div>
          <v-toolbar-items v-if="ko.id > 0">
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="show_print_options = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <sabira_icon icon="file-pdf" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>KO pdf</span>
            </v-tooltip>
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="show_email = true" v-bind="attrs" v-on="on">
                  <sabira_icon icon="email_invoice" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>Pošalji KO</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="show_delete_options = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <sabira_icon icon="trash" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>Obriši KO</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pa-4">
          <div style="display:grid;grid-template-columns:1fr 1fr;">
            <v-text-field
              v-model="ko.ko_number"
              label="Broj knjižne obavijesti"
              outlined
              maxlength="100"
              counter
              class="mr-4"
            ></v-text-field>
            <webpage_lookup_faktura
              update="wp_faktura_changed"
              :selected_id="ko.invoice_id"
            ></webpage_lookup_faktura>
          </div>
          <div
            style="margin-top:0.1rem;display:grid;grid-template-columns:1fr 1fr;"
          >
            <v-dialog
              ref="dialog_ko_date"
              v-model="modal_ko_date"
              :return-value.sync="ko.ko_date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="ko_date_formatted"
                  label="Datum knjižne obavijesti"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  :width="80"
                  class="mr-4"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="ko.ko_date"
                @change="save_ko_date"
                locale="bs-bs"
                :first-day-of-week="1"
                :show-week="true"
              >
              </v-date-picker>
            </v-dialog>

            <v-text-field
              v-model="ko_invoice_date_formatted"
              label="Datum fakture"
              prepend-inner-icon="mdi-calendar"
              readonly
              outlined
              :width="80"
            ></v-text-field>
          </div>
          <div
            style="margin-top:0.1rem;display:grid;grid-template-columns:1fr 1fr;grid-row-gap: 1rem;"
          >
            <v-text-field
              outlined
              class="mr-4"
              label="Klijent"
              auto-grow
              v-model="ko.client_name"
              readonly
            >
            </v-text-field>
            <v-text-field
              hide-details
              v-model="ko.reklam_fiscal_number"
              outlined
              label="Broj reklamiranog fiskalnog računa"
            ></v-text-field>
          </div>
          <div
            style="margin-top:0.1rem;align-items:center;display:grid;grid-template-columns: 0.95fr 1fr;"
          >
            <webpage_lookup_artikli
              update="wp_artikal_changed"
            ></webpage_lookup_artikli>
            <v-btn
              class="ml-0"
              icon
              color="primary"
              dark
              @click="dodaj_artikal()"
              ><sabira_icon
                icon="plus"
                fill="grey"
                :width="38"
                :height="38"
                :strokewidth="3"
                class="ml-6"
              ></sabira_icon
            ></v-btn>
          </div>
          <v-data-table
            class="mt-2"
            :items="ko.artikli"
            :headers="headers"
            disable-pagination
            hide-default-footer
            no-data-text="Podaci ne postoje za odabranu kategoriju"
          >
            <template v-slot:[`item.kom`]="{ item }">
              <v-text-field
                v-model.number="item.kom"
                outlined
                dense
                hide-details
                type="number"
              ></v-text-field>
            </template>
            <template v-slot:[`item.ukupno`]="{ item }">
              {{ $n(parseFloat(item.ukupno).toFixed(2)) }}
            </template>
            <template v-slot:[`item.jm_id`]="{ item }">
              <webpage_lookup_jedinice_mjere
                :selected_id="item.jm_id"
                :reference_id="item.id"
                update="wp_event_jm_updated"
              ></webpage_lookup_jedinice_mjere>
            </template>
            <template v-slot:[`item.rabat`]="{ item }">
              <v-text-field
                v-model.number="item.rabat"
                outlined
                hide-details
                dense
                type="number"
              ></v-text-field>
            </template>
            <template v-slot:[`item.cijena`]="{ item }">
              {{ $n(parseFloat(item.cijena).toFixed(2)) }}
            </template>
            <template v-slot:[`body.append`]>
              <tr>
                <td :colspan="7" style="text-align:right">
                  Ukupno bez PDV-a:
                </td>
                <td style="text-align:left">
                  {{ $n(parseFloat(ko_total).toFixed(2)) }}
                </td>
              </tr>
              <tr>
                <td :colspan="7" style="text-align:right">
                  PDV:
                </td>
                <td style="text-align:left">
                  {{ $n(parseFloat(tax_total).toFixed(2)) }}
                </td>
              </tr>
              <tr>
                <td :colspan="7" style="text-align:right">
                  Odobreni iznos:
                </td>
                <td style="text-align:left">
                  {{ $n(parseFloat(grand_total).toFixed(2)) }}
                </td>
              </tr>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn icon @click="remove_artikal(item)"
                ><sabira_icon icon="trash" fill="grey"></sabira_icon
              ></v-btn>
            </template>
          </v-data-table>
          <v-text-field
            outlined
            v-model="ko.ko_note"
            label="Napomena"
            maxlength="255"
            counter
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="close_dialog">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="is_btn_loading" text depressed @click="save_ko()"
            >Snimi</v-btn
          >
        </v-card-actions>
        <vue-qr
          :text="'KO broj: ' + ko.ko_number"
          :margin="0"
          :callback="raw_qrcode"
          :whiteMargin="false"
          :width="60"
          style="display:none;"
          backgroundColor="transparent"
        ></vue-qr>
      </v-card>
    </template>
    <v-dialog width="30rem" persistent scrollable v-model="show_print_options">
      <v-card>
        <v-card-title class="pb-0 mb-0"
          >Dodatni sadržaj u PDF dokumentu</v-card-title
        >
        <v-card-text class="pt-0 mt-0">
          <v-list color="transparent">
            <v-list-item>
              <v-checkbox
                label="Pečat"
                v-model="print_pecat"
                ripple
                hide-details
              ></v-checkbox>
            </v-list-item>
            <v-list-item>
              <v-checkbox
                label="Potpis"
                v-model="print_potpis"
                ripple
                hide-details
              ></v-checkbox>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="show_print_options = false">Zatvori</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="print(false)">Prikaži</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="30rem" persistent scrollable v-model="show_delete_options">
      <v-card>
        <v-card-title class="pb-0 mb-0"
          >Brisanje knjižne obavijesti</v-card-title
        >
        <v-card-text class="pt-0 mt-0">
          <v-list color="transparent">
            <v-list-item>
              <v-list-item-content>
                {{ "Želite obrisati knjižnu obavijest " + ko.ko_number + "?" }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="show_delete_options = false">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="delete_ko()">Obriši</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <sabira_email
      :sender="email.sender"
      :message="email.message"
      :subject="email.subject"
      :attachments="email.attachments"
      :recipients="email.recipients"
      :visible="show_email"
      close="close_email_dialog"
    ></sabira_email>
  </v-dialog>
</template>
<script>
import VueQr from "vue-qr";
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    webpage_lookup_faktura: () => import("@/components/lookups/fakture_ko"),
    webpage_lookup_artikli: () => import("@/components/lookups/artikli"),
    webpage_lookup_jedinice_mjere: () =>
      import("@/components/lookups/jedinice_mjere"),
    sabira_email: () => import("@/components/email"),
    VueQr,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    close: {
      type: String,
      default: null,
    },
  },
  computed: {
    ko_date_formatted() {
      return this.ko.ko_date
        ? this.$moment(new Date(this.ko.ko_date)).format("Do MMMM YYYY")
        : null;
    },
    ko_invoice_date_formatted() {
      return this.ko.invoice_date
        ? this.$moment(new Date(this.ko.invoice_date)).format("Do MMMM YYYY")
        : null;
    },
    completion_date_formatted() {
      return this.ko.completion_date
        ? this.$moment(new Date(this.ko.completion_date)).format("Do MMMM YYYY")
        : null;
    },
    ko_total() {
      return typeof this.ko.artikli !== "undefined" &&
        this.ko.artikli !== null &&
        this.ko.artikli.length
        ? this.ko.artikli
            .map((x) => x.ukupno)
            .reduce((a, b) => {
              return a + b;
            })
        : 0;
    },
    tax_total() {
      return typeof this.ko.artikli !== "undefined" &&
        this.ko.artikli !== null &&
        this.ko.artikli.length
        ? this.ko.artikli
            .map((x) => x.pdv_total)
            .reduce((a, b) => {
              return a + b;
            })
        : 0;
    },
    grand_total() {
      return typeof this.ko.artikli !== "undefined" &&
        this.ko.artikli !== null &&
        this.ko.artikli.length
        ? this.ko.artikli
            .map((x) => x.total)
            .reduce((a, b) => {
              return a + b;
            })
        : 0;
    },
  },
  data: () => ({
    title1: "KO",
    title2: "Kreiranje nove knjižne obavijesti",
    qrcode_image: null,
    show_print_options: false,
    show_delete_options: false,
    print_pecat: true,
    print_potpis: true,
    show_email: false,
    is_btn_loading: false,
    modal_ko_date: false,
    is_loading: true,
    visible: false,
    ko: {
      artikli: [],
      id: 0,
      ko_number: null,
      invoice_id: null,
      invoice_number: null,
      klijent_id: null,
      client_name: null,
      reklam_fiscal_number: null,
      ko_date: new Date().toISOString().substr(0, 10),
      invoice_date: null,
      work_desc: null,
      ko_note: null,
      account_id: null,
    },
    email: {
      recipients: [
        {
          name: null,
          email: null,
        },
      ],
      sender: {
        name: null,
        email: null,
      },
      subject: null,
      message: null,
      attachments: [],
    },
    headers: [
      {
        text: "Šifra",
        value: "sifra",
        align: "left",
        width: "5rem",
      },
      {
        text: "Naziv",
        value: "naziv",
        align: "left",
        width: "10rem",
      },
      {
        text: "Količina",
        value: "kom",
        align: "left",
        width: "7rem",
      },
      {
        text: "JM",
        value: "jm_id",
        width: "3rem",
        align: "left",
      },
      {
        text: "Cijena",
        value: "cijena",
        width: "7rem",
        align: "left",
      },
      {
        text: "Rabat %",
        value: "rabat",
        width: "6rem",
        align: "left",
      },
      {
        text: "Ukupno bez PDV-a",
        value: "ukupno",
        align: "left",
        width: "8rem",
      },
      {
        text: null,
        value: "actions",
        width: "30px",
      },
    ],
  }),
  watch: {
    visible: {
      handler() {
        if (this.id > 0) {
          this.get_item();
        } else {
          this.ko = {
            artikli: [],
            id: 0,
            ko_number: null,
            invoice_id: null,
            invoice_number: null,
            klijent_id: null,
            client_name: null,
            reklam_fiscal_number: null,
            ko_date: new Date().toISOString().substr(0, 10),
            invoice_date: null,
            work_desc: null,
            ko_note: null,
            account_id: null,
          };
          this.generate_ko_number();
          this.is_loading = false;
        }
      },
      immediate: false,
    },
    show_email: {
      handler() {
        if (this.show_email) {
          this.email.attachments = [];
          this.print(true);
        }
      },
    },
    "ko.artikli": {
      handler() {
        this.ko.artikli.forEach((e_artikal) => {
          e_artikal.ukupno =
            e_artikal.kom *
            (e_artikal.cijena - (e_artikal.cijena * e_artikal.rabat) / 100);
          e_artikal.pdv_total =
            e_artikal.pdv_postotak > 0
              ? (e_artikal.pdv_postotak / 100) * e_artikal.ukupno
              : 0;
          e_artikal.total = e_artikal.ukupno + e_artikal.pdv_total;
        });
      },
      deep: true,
    },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (this.ko.ko_number == null || this.ko.ko_number.length == 0) {
          has_errors = true;
          reject("Broj radnog naloga polje je obavezno");
        }
        if (
          this.ko.invoice_number == null ||
          this.ko.invoice_number.length == 0
        ) {
          has_errors = true;
          reject("Broj fakture polje je obavezno");
        }
        if (
          this.ko.reklam_fiscal_number == null ||
          this.ko.reklam_fiscal_number.length == 0 ||
          this.ko.reklam_fiscal_number < 0 ||
          this.ko.reklam_fiscal_number > 2147483647
        ) {
          has_errors = true;
          reject("Reklamirani fiskalni račun polje nije ispravno popunjeno");
        }
        if (this.ko.artikli.length == 0) {
          has_errors = true;
          reject("Artikli polje je obavezno");
        }
        for (let i = 0; i < this.ko.artikli.length; i++) {
          const item = this.ko.artikli[i];
          if (
            item.cijena == null ||
            item.cijena === 0 ||
            item.cijena.length === 0
          ) {
            reject(`Cijena artikla polje je obavezno`);
          }
          if (
            item.rabat == null ||
            item.rabat.length === 0 ||
            item.rabat < 0 ||
            item.rabat > 100
          ) {
            reject(`Rabat artikla polje nije ispravno ispunjeno`);
          }
          if (
            item.kom == null ||
            item.kom === 0 ||
            item.kom.length === 0 ||
            item.kom < 0 ||
            item.kom > 2147483647
          ) {
            reject(`Količina artikla polje nije ispravno ispunjeno`);
          }
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    remove_artikal(item) {
      this.ko.artikli.splice(this.ko.artikli.indexOf(item), 1);
    },
    dodaj_artikal() {
      if (
        this.selected_artikal !== null &&
        typeof this.selected_artikal !== "undefined"
      ) {
        if (
          typeof this.ko.artikli.find(
            (x) => x.id == this.selected_artikal.id
          ) !== "undefined"
        ) {
          var e_artikal = this.ko.artikli.find(
            (x) => x.id == this.selected_artikal.id
          );
          e_artikal.kom += 1;
        } else {
          this.ko.artikli.push({
            id: this.selected_artikal.id,
            sifra: this.selected_artikal.sifra,
            naziv: this.selected_artikal.naziv,
            cijena: this.selected_artikal.vpc,
            kom: 0,
            rabat: 0,
            ukupno: this.selected_artikal.vpc,
            pdv_postotak: this.selected_artikal.pdv_postotak,
            pdv_total:
              (this.selected_artikal.pdv_postotak / 100) *
              this.selected_artikal.vpc,
            jm_id: 1,
            total:
              this.selected_artikal.vpc +
              (this.selected_artikal.vpc * this.selected_artikal.pdv_postotak) /
                100,
          });
        }
      } else {
        this.$webpageEventBus.$emit("show_status", {
          type: "error",
          message: "Odaberite artikal",
          timeout: 2000,
        });
      }
    },
    get_item() {
      this.$http({
        method: "POST",
        url: "/ko/get_ko",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
        },
      }).then((resp) => {
        this.ko = resp.data.result;
        this.is_loading = false;
        this.ko.ko_date = this.$moment(new Date(this.ko.ko_date))
          .local()
          .format("YYYY-MM-DD HH:SS");
        if (this.ko.invoice_date != null) {
          this.ko.invoice_date = this.$moment(new Date(this.ko.invoice_date))
            .local()
            .format("YYYY-MM-DD HH:SS");
        } else {
          this.ko.invoice_date = null;
        }
        this.email.subject = "KO broj " + this.ko.ko_number;
        this.email.sender = {
          name: this.$store.getters.user.name,
          email: this.$store.getters.user.email,
        };
        this.email.recipients = [
          {
            name: this.ko.naziv,
            email: this.ko.email,
          },
        ];
        this.email.message =
          "Poštovana/ni, u prilogu se nalazi knjižna obavijest broj " +
          this.ko.ko_number +
          ".pdf.";
      });
    },
    close_dialog() {
      this.$webpageEventBus.$emit(
        this.close !== null ? this.close : "close_ko_note"
      );
    },
    save_ko_date() {
      this.$refs.dialog_ko_date.save(this.ko.ko_date);
    },
    save_completion_date() {
      this.$refs.dialog_completion_date.save(this.ko.completion_date);
    },
    save_ko() {
      this.validate()
        .then(() => {
          this.is_btn_loading = true;
          this.ko.account_id = this.$store.getters.user.account_id;
          this.ko.ko_date = this.$moment(this.ko.ko_date)
            .local()
            .format("YYYY-MM-DD HH:SS");
          if (this.ko.invoice_date != null) {
            this.ko.invoice_date = this.$moment(this.ko.invoice_date)
              .local()
              .format("YYYY-MM-DD HH:SS");
          } else {
            this.ko.invoice_date = null;
          }
          this.$http({
            method: "POST",
            url: "/ko/update",
            data: this.ko,
            headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }).then((resp) => {
            if (resp.status == 200) {
              this.$webpageEventBus.$emit("show_status", {
                type: "success",
                message: "KO je ažuriran",
                timeout: 2000,
              });
              this.$webpageEventBus.$emit("evt_close_ko_note");
              this.close_dialog();
              this.$webpageEventBus.$emit("reload_data");
            } else {
              this.$webpageEventBus
                .$emit("show_status", {
                  type: "error",
                  message: resp.data.message,
                  timeout: 4000,
                })
                .finally(() => {
                  this.is_btn_loading = false;
                });
            }
          });
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e,
            timeout: 4000,
          });
        });
    },
    generate_ko_number() {
      if (this.id == 0 || this.id == null) {
        var starting_number = 0;
        this.$http({
          method: "POST",
          url: "/ko/count",
          data: {
            account_id: this.$store.getters.user.account_id,
          },
        }).then((resp) => {
          this.ko.ko_number =
            "KO" +
            "-" +
            parseInt(starting_number + resp.data[0].total + 1) +
            "-" +
            this.$moment(new Date(this.ko.ko_date)).format("MM") +
            "/" +
            this.$moment(new Date(this.ko.ko_date)).format("YY");
        });
      }
    },
    delete_ko() {
      this.$http({
        method: "POST",
        url: "/ko/delete",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
          ko_number: this.ko.ko_number,
        },
      }).then((resp) => {
        if (resp.status == 200) {
          this.$webpageEventBus.$emit("show_status", {
            type: "success",
            message: "KO je obrisan",
            timeout: 2000,
          });
          this.close_dialog();
          this.$webpageEventBus.$emit("reload_data");
        } else {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: resp.data.message,
            timeout: 4000,
          });
        }
      });
    },
    raw_qrcode(dataUrl) {
      this.qrcode_image = dataUrl;
    },
    print(for_email) {
      this.$helpers
        .generate_ko_pdf(this.ko, this.print_pecat, this.print_potpis)
        .then((r) => {
          var ko_pdf = r;
          if (for_email) {
            this.email.attachments.push({
              filename: this.ko.ko_number + ".pdf",
              content: ko_pdf.content,
              encoding: "binary",
            });
          } else {
            ko_pdf.raw_doc.save(this.ko.ko_number + ".pdf");
            //invoice_pdf.raw_doc.output("dataurlnewwindow");
          }
        });
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("wp_faktura_changed", (selected_item) => {
        if (selected_item !== null) {
          this.ko.invoice_id = selected_item.id;
          this.ko.invoice_number = selected_item.broj;
          this.ko.invoice_date = selected_item.datum;
          this.ko.klijent_id = selected_item.klijent_id;
          this.ko.client_name = selected_item.client_name;
        } else {
          this.ko.invoice_id = null;
          this.ko.invoice_number = null;
        }
      });
      this.$webpageEventBus.$on("wp_artikal_changed", (artikal) => {
        this.selected_artikal = artikal;
      });
      this.$webpageEventBus.$on("wp_event_jm_updated", (resp) => {
        var artikal = this.ko.artikli.find((x) => x.id == resp.id);
        if (typeof artikal !== "undefined") {
          artikal.jm_id = resp.jm.id;
        }
      });
      this.$webpageEventBus.$on("close_email_dialog", () => {
        this.show_email = false;
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("wp_client_changed");
      this.$webpageEventBus.$off("wp_worker_changed");
      this.$webpageEventBus.$off("wp_artikal_changed");
      this.$webpageEventBus.$off("wp_event_jm_updated");
      this.$webpageEventBus.$off("wp_faktura_changed");
      this.$webpageEventBus.$off("close_email_dialog");
    },
  },
  mounted() {
    this.visible = true;
    this.setup_event_listeners();
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
};
</script>
<style scoped>
.v-tooltip__content {
  color: black;
  opacity: 1;
}
</style>
